import TeacherCard from './TeacherCard';

export default TeacherCard;
